import axios from 'axios'
import { getIdToken } from '@/utils/auth'
import { API_BASE } from '@/services/api'
import { PricingPlan, SelectedAddOn } from '@/types/pricing'

/** Redirect to Stripe checkout page with a single price */
export async function redirectToCheckout(priceId: string) {
  const token = await getIdToken()

  const { data } = await axios.post(
    `${API_BASE}/createCheckoutSession`,
    {
      priceId,
      successUrl: window.location.origin + '/success',
      cancelUrl: window.location.origin + '/cancel',
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )

  window.location.href = data.url
}

/** Redirect to Stripe checkout page with multiple line items for plans and add-ons */
export async function redirectToCheckoutWithAddOns(
  plan: PricingPlan,
  selectedAddOns: SelectedAddOn[] = []
) {
  const token = await getIdToken()

  const lineItems = [{ price: plan.priceId, quantity: 1 }]

  // Add add-ons as additional line items with their quantities
  selectedAddOns.forEach((selectedAddOn) => {
    if (selectedAddOn.quantity > 0) {
      lineItems.push({ price: selectedAddOn.addOn.priceId, quantity: selectedAddOn.quantity })
    }
  })

  const { data } = await axios.post(
    `${API_BASE}/createCheckoutSession`,
    {
      lineItems,
      successUrl: window.location.origin + '/success',
      cancelUrl: window.location.origin + '/cancel',
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )

  window.location.href = data.url
}

/** Create checkout session for API access addon */
export async function createApiAccessCheckout(params: { successUrl: string; cancelUrl: string }) {
  const token = await getIdToken()

  const { data } = await axios.post(`${API_BASE}/createApiAccessCheckout`, params, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })

  return data
}

/** Cancel API access subscription */
export async function cancelApiAccess() {
  const token = await getIdToken()

  const { data } = await axios.post(
    `${API_BASE}/cancelApiAccess`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )

  return data
}
